import { createFileRoute } from "@tanstack/react-router";

import ChallengeProfile from "@/components/ChallengeProfile/ChallengeProfile";

const Component = () => {
  const { challengeUuid } = Route.useParams();
  return <ChallengeProfile challengeUuid={challengeUuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/challenges/$challengeUuid/profile")({
  component: () => <Component />,
});
